import React, { Component } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import HomeNav from "components/Navbars/HomeNav.js";
import Pagination from 'react-bootstrap/Pagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Select from 'react-select';

// reactstrap components
import {
  Card,
  CardBody,  
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Collapse,
  Input,
  InputGroupText,
  InputGroup
} from "reactstrap";

// core components
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import { 
  allPatientsFetchAction,
  fetchPatiensByPatientNameAction,
  fetchPatienByPhoneAction,
  fetchPatiensByAttenderNameAction
 } from 'actions/patientActions';
import { fetchLocalityAction } from 'actions/localityActions';
import { saveSecondaryDistrictsAction } from 'actions/adminActions';
const moment = require('moment');

class LiquidLoveRequests extends Component {
  constructor(props) {
    super(props);
    this.state ={
      firstFocus: '',
      lastFocus: '',
      resultSize: 5,
      country: '',
      stateLocation: '',
      sortOrder: 'ASC',
      myRequestsFilter: false,
      districtOptions: [],
      selectedDistrict: [],
      statusOptions: [
        {value: 'Open', label: 'Open'},
        {value: 'Verified', label: 'Verified'},
        {value: 'Volunteered', label: 'Volunteered'},
        {value: 'Partially fulfilled', label: 'Partially fulfilled'},
        {value: 'Fulfilled', label: 'Fulfilled'},
        {value: 'Cancelled-Closed', label: 'Cancelled-Closed'},
        {value: 'Partially Fulfilled-Closed', label: 'Partially Fulfilled-Closed'},
        {value: 'Fulfilled-Closed', label: 'Fulfilled-Closed'},
        {value: 'Unknown donor-Closed', label: 'Unknown donor-Closed'},
        {value: 'Not Fulfilled-Closed', label: 'Not Fulfilled-Closed'},
      ],
      selectedStatus: [
        {value: 'Open', label: 'Open'},
        {value: 'Verified', label: 'Verified'},
        {value: 'Volunteered', label: 'Volunteered'},
        {value: 'Partially fulfilled', label: 'Partially fulfilled'},
        {value: 'Fulfilled', label: 'Fulfilled'}
      ],
      filterByDistrictAndStatus: true,
      filterByOthers: false,
      phone: '',
      patientName: '',
      attenderName: '',
      activeFilter: '',
      pageNum: 0
    }
    this.handlePatientClick = this.handlePatientClick.bind(this);
    this.constructPaginationLinks = this.constructPaginationLinks.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.sizeChanged = this.sizeChanged.bind(this);
    this.sortChanged = this.sortChanged.bind(this);
    this.handleMyRequests = this.handleMyRequests.bind(this);
    this.handleDistrictChange = this.handleDistrictChange.bind(this);
    this.handleFilterByDistrictToggle = this.handleFilterByDistrictToggle.bind(this);
    this.handleFilterByOthersToggle = this.handleFilterByOthersToggle.bind(this);
    this.filterByPatientName = this.filterByPatientName.bind(this);
    this.handleChangePatientName = this.handleChangePatientName.bind(this);
    this.filterByDistrict = this.filterByDistrict.bind(this);
    this.filterByPhone = this.filterByPhone.bind(this);
    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.filterByAttenderName = this.filterByAttenderName.bind(this);
    this.handleChangeAttenderName = this.handleChangeAttenderName.bind(this);
    this.handleSaveSecondaryDistricts = this.handleSaveSecondaryDistricts.bind(this);
  }
  
  componentWillMount() {
    document.title = 'Liquid Love Requests';
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
   
    if(!this.props.response.login.isSignedIn)
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/requests';         //user not logged in..redirect to login page
    else{
      this.state.country = this.props.response.login.adminCountry;
      this.state.stateLocation = this.props.response.login.adminStateLocation;
      let primaryDistrictItem = {value: '', label: ''};
      primaryDistrictItem.value = this.props.response.login.adminDistrict;
      primaryDistrictItem.label = this.props.response.login.adminDistrict;

      this.state.selectedDistrict.push(primaryDistrictItem);
      
      if(this.props.response.login.secondaryDistricts !== undefined)
        this.props.response.login.secondaryDistricts.map((secondaryDistrict) => {
          let secondaryDistrictItem = {value: '', label: ''};
          secondaryDistrictItem.value = secondaryDistrict;
          secondaryDistrictItem.label = secondaryDistrict;
          this.state.selectedDistrict.push(secondaryDistrictItem);
        })

      let districts = [];
      this.state.selectedDistrict.map((district) => {
        districts.push(district.value);
      })
      
      let statuses = [];
      this.state.selectedStatus.map((status) => {
        statuses.push(status.value);
      })

      const payload = { 
        pageNum: 0,
        size: this.state.resultSize,
        status: statuses,
        country: this.state.country,
        stateLocation: this.state.stateLocation,
        districts: districts,
        adminName: this.state.myRequestsFilter ? this.props.response.login.adminName : 'All',
        sortOrder: this.state.sortOrder,
        token: this.props.response.login.userToken
      }
      const localityPayload = {
        country: this.state.country,
        stateLocation: this.state.stateLocation,        
        token: this.props.response.login.userToken,
      };
      this.state.activeFilter = 'district';
      this.state.pageNum = 0;
      this.props.dispatch(allPatientsFetchAction(payload));
      this.props.dispatch(fetchLocalityAction(localityPayload));
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("landing-page");
    document.body.classList.remove("sidebar-collapse");
    this.state.districtOptions = [];
    this.state.statusOptions = [];
    this.state.selectedStatus = [];
    this.setState({phone: ''});
    this.state.pageNum = 0;
    this.state.activeFilter = 'district';

    if(this.props.response.patient && this.props.response.patient.hasOwnProperty('noServiceResponse'))
      this.props.response.patient.noServiceResponse = false;

    if(this.props.response.admin && this.props.response.admin.hasOwnProperty('saveSecondaryDistrictsResponse') &&
      this.props.response.admin.saveSecondaryDistrictsResponse !== 'undefined')
        delete this.props.response.admin.saveSecondaryDistrictsResponse;
  }
    
  handleChangePatientName = (e) => this.setState({patientName: e.target.value})

  filterByPatientName() {
    const data = {
      patientName: this.state.patientName,
      pageNum: this.state.pageNum,
      size: this.state.resultSize,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }
    this.state.activeFilter = 'patientName';
    this.state.phone = '';
    this.state.attenderName = '';
    this.props.dispatch(fetchPatiensByPatientNameAction(data));
  }

  handleChangePhone = (e) => this.setState({phone: e.target.value})

  filterByPhone() {
    const data = {
      phone: this.state.phone,
      pageNum: this.state.pageNum,
      size: this.state.resultSize,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }

    this.setState({activeFilter: 'phone'})
    this.state.patientName = '';
    this.state.attenderName = '';
    this.props.dispatch(fetchPatienByPhoneAction(data));
  }

  handleChangeAttenderName = (e) => this.setState({attenderName: e.target.value})

  filterByAttenderName() {
    const data = {
      attenderName: this.state.attenderName,
      pageNum: this.state.pageNum,
      size: this.state.resultSize,
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }
    this.state.activeFilter = 'attenderName';
    this.state.patientName = '';
    this.state.phone = '';

    this.props.dispatch(fetchPatiensByAttenderNameAction(data));
  }

  handleFilterByDistrictToggle(){
    this.setState({ filterByDistrictAndStatus: !this.state.filterByDistrictAndStatus });
    this.state.patientName = '';
    this.state.phone = '';
    this.state.attenderName = '';
    this.state.pageNum = 0;

    //if this toggle is being opened, close the other toggle
    if(!this.state.filterByDistrictAndStatus) {
      this.setState({ filterByOthers: false });
      this.filterByDistrict();
    }  
  }

  handleFilterByOthersToggle(){
    this.setState({ filterByOthers: !this.state.filterByOthers });
    //if this toggle is being opened, close the other toggle
    if(!this.state.filterByOthers)
      this.setState({ filterByDistrictAndStatus: false });

    this.state.pageNum = 0;  
  }

  handlePatientClick(rowIndex) {
    this.props.navigate('/liquidlove/patient-details?reqId=' + this.props.response.patient.allPatientRequests.content[rowIndex].id 
    + '&country=' + this.props.response.patient.allPatientRequests.content[rowIndex].country + '&state=' + this.props.response.patient.allPatientRequests.content[rowIndex].stateLocation
    + '&district=' + this.props.response.patient.allPatientRequests.content[rowIndex].district
    + '&status=' + this.props.response.patient.allPatientRequests.content[rowIndex].status);
  }

  handleDistrictChange = (selectedDistrict) => {    
    this.state.selectedDistrict = selectedDistrict;
    this.state.pageNum = 0;
    this.filterByDistrict();
  };

  handleStatusChange = (selectedStatus) => {    
    this.state.selectedStatus = selectedStatus;
    this.state.pageNum = 0;
    this.filterByDistrict();
  };

  handleSaveSecondaryDistricts() {    
    let selectedDistricts = this.state.selectedDistrict;
    //remove primary district from selected districts
    let tempSet = selectedDistricts.filter(item => item.value !== this.props.response.login.adminDistrict);
    let tempDistricts = [];
    tempSet.map((district) => {
      tempDistricts.push(district.value);
    })
    const payload = { 
      id: this.props.response.login.adminId,
      secondaryDistricts: tempDistricts,
      token: this.props.response.login.userToken
    }
    
    this.props.dispatch(saveSecondaryDistrictsAction(payload));

  };

  constructPaginationLinks(totalPages,currentPage) {
    let items = [];
    if (totalPages === 1 || totalPages === 0) {
      return items;
    }

    if (totalPages > 10) {      
      if (currentPage > 0) {
        items.push(
          <Pagination.Item key={1}>{1}</Pagination.Item>
        );
        if(currentPage != 1){
          items.push(
            <Pagination.Ellipsis />
          );
          items.push(
            <Pagination.Item key={currentPage}>{currentPage}</Pagination.Item> 
          );
        }
      }
      //Current page
      items.push(
        <Pagination.Item key={currentPage +1} active>
          {currentPage +1}
        </Pagination.Item> 
      );

      if (currentPage < totalPages -1) {
        items.push(
          <Pagination.Item key={currentPage +2}>{currentPage +2}</Pagination.Item>
        );
        if(currentPage < totalPages -2){
          items.push(
            <Pagination.Ellipsis />
          );
          items.push(
            <Pagination.Item key={totalPages}>{totalPages}</Pagination.Item>
          );
        }
      }      
      return items;
    }
    
    for (let number = 0; number < totalPages; number++) {
      let index = number + 1;

      items.push(
        <Pagination.Item key={index} active={index === (currentPage) + 1}>
          {index}
        </Pagination.Item>
      );
    }
    return items;
  }

  handleMyRequests(isFilterOn){
    this.state.myRequestsFilter = isFilterOn;
    this.state.pageNum = 0;
    this.filterByDistrict();
  }

  pageChanged(e) {
    if(e.target.text === undefined)
      return;
    
    let index = e.target.text;
    this.state.pageNum =  index -1;
    
    if(this.state.activeFilter === 'district')
      this.filterByDistrict();
    else if(this.state.activeFilter === 'patientName')
      this.filterByPatientName();
    else if(this.state.activeFilter === 'attenderName')  
      this.filterByAttenderName();
    else if(this.state.activeFilter === 'phone')  
      this.filterByPhone();    
  }

  sizeChanged(e){
    this.state.resultSize = parseInt(e.target.text);
    this.state.pageNum = 0;
    if(this.state.activeFilter === 'district')
      this.filterByDistrict();
    else if(this.state.activeFilter === 'patientName')
      this.filterByPatientName();
    else if(this.state.activeFilter === 'attenderName')  
      this.filterByAttenderName();
    else if(this.state.activeFilter === 'phone')  
      this.filterByPhone();
  }

  sortChanged(sortOrder){
    if(this.state.sortOrder === sortOrder) //if sort order is already same as requested sort order, do nothing
      return;

    this.state.pageNum = 0;
    this.state.sortOrder = sortOrder;
    
    if(this.state.activeFilter === 'district')
      this.filterByDistrict();
    else if(this.state.activeFilter === 'patientName')
      this.filterByPatientName();
    else if(this.state.activeFilter === 'attenderName')  
      this.filterByAttenderName();
    else if(this.state.activeFilter === 'phone')  
      this.filterByPhone();
  }

  filterByDistrict(){
    let districts = [];
    this.state.selectedDistrict.map((district) => {
        districts.push(district.value);
    })
    
    let statuses = [];
    this.state.selectedStatus.map((status) => {
      statuses.push(status.value);
    })

    const payload = { 
      pageNum: this.state.pageNum,
      size: this.state.resultSize,
      status: statuses,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      districts: districts,
      adminName: this.state.myRequestsFilter ? this.props.response.login.adminName : 'All',
      sortOrder: this.state.sortOrder,
      token: this.props.response.login.userToken
    }
    this.state.activeFilter = 'district';
    this.props.dispatch(allPatientsFetchAction(payload));
  }

  render() {    
    let message = '';
    let totalPages = 0;
    let currentPage = 0;
    this.state.districtOptions = [];
    if(this.props.response.locality.response && this.props.response.locality.response.districts){
      this.props.response.locality.response.districts.map((district) => {
        let districtItem = {value: '', label: ''};
        districtItem.value = district;
        districtItem.label = district;
        this.state.districtOptions.push(districtItem);
      })
    }  

    const { selectedDistrict } = this.state;
    const { selectedStatus } = this.state;
    
    if(this.props.response.patient &&
      this.props.response.patient.hasOwnProperty('allPatientRequests') &&
      this.props.response.patient.allPatientRequests !== undefined){
      if(this.props.response.patient.allPatientRequests.hasOwnProperty('error')){
        if(this.props.response.patient.allPatientRequests.status === 401){
          message = 'Your session has expired. Please login again'
        }
        else
          message = 'Sairam! Sorry. We are not able to process your request.'
      }
      else{
        totalPages = this.props.response.patient.allPatientRequests.totalPages;
        currentPage = this.props.response.patient.allPatientRequests.number;
      }  
    }
    
    if(!this.props.response.login.isSignedIn) 
        return <Navigate to={'/liquidlove/login'} />
    
    if(this.props.response.patient && this.props.response.patient.noServiceResponse)
        message = 'Sairam. Sorry! We are not able to get the details. Please try later.';

    if(this.props.response.admin && this.props.response.admin.hasOwnProperty('saveSecondaryDistrictsResponse') &&
        this.props.response.admin.saveSecondaryDistrictsResponse !== 'undefined' &&
        this.props.response.admin.saveSecondaryDistrictsResponse.hasOwnProperty('status') &&
        this.props.response.admin.saveSecondaryDistrictsResponse.status === 'success'){
          let tempSet1 = this.state.selectedDistrict.filter(item => item.value !== this.props.response.login.adminDistrict);
          let tempSet2 = [];
          tempSet1.map((item) => {tempSet2.push(item.value);})
          this.props.response.login.secondaryDistricts = tempSet2;
        }
    return (      
          <div className="wrapper">            
            <HomePageHeader />
            <HomeNav adminName={this.props.response.login.adminName}/>
            <div
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
            <Container>
              <Card>
                <CardBody align="center" tag="h6">Liquid Love Requests</CardBody>
              </Card>
            <UncontrolledDropdown className="btn-group" size="sm">
                <DropdownToggle
                  aria-expanded={false}
                  aria-haspopup={true}
                  caret
                  color="primary"
                  data-toggle="dropdown"
                  type="button"
                >
                  Size {this.state.resultSize}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem  href="5" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>5</DropdownItem>
                  <DropdownItem  href="10" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>10</DropdownItem>
                  <DropdownItem  href="15" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>15</DropdownItem>
                </DropdownMenu>
                </UncontrolledDropdown>
            <div style={{color: "white"}}>Filter by district and status
                <button onClick={() => this.handleFilterByDistrictToggle()} id="filterByDistrictToggler" className="btn btn-primary btn-icon btn-round">
                  <i className="now-ui-icons arrows-1_minimal-down"></i>
                </button>
            </div>
            <Collapse isOpen={this.state.filterByDistrictAndStatus}>
            <div style={{color: "white"}}>Select districts</div>
            <Select
              className="btn-group" size="md"
              value={selectedDistrict}
              onChange={this.handleDistrictChange}
              options={this.state.districtOptions}
              isMulti
            />
            
            <button onClick={this.handleSaveSecondaryDistricts} id="saveSecondaryDistricts" className="btn btn-primary btn-icon btn-round">
              <i className="now-ui-icons ui-1_simple-add"></i>
            </button>
            
            <br/>
            <div style={{color: "white"}}>Select status</div>
            <Select
              className="btn-group" size="md"
              value={selectedStatus}
              onChange={this.handleStatusChange}
              options={this.state.statusOptions}
              isMulti
            /><br/>            
              <button alt="Show only requests last handled by me" size="sm" onClick={() => this.handleMyRequests(!this.state.myRequestsFilter)}
                type="button"
                class={'btn' + (this.state.myRequestsFilter ? ' btn-primary ' : ' btn-default ') + 'btn-sm'}>
                Show only requests last handled by me
              </button>
            </Collapse>
            <div style={{color: "white"}}>Filter by patient / attender name, phone
                <button onClick={() => this.handleFilterByOthersToggle()} id="filterByOthersToggler" className="btn btn-primary btn-icon btn-round">
                  <i className="now-ui-icons arrows-1_minimal-down"></i>
                </button>
            </div>
            <Collapse isOpen={this.state.filterByOthers}>
            <Card className="card-signup" data-background-color="blue">  
            <InputGroup
                          className={
                            "no-border input-sm" +
                            (this.state.firstFocus ? " input-group-focus" : "")
                          }
                        >
                            <InputGroupText>
                            Patient name
                            </InputGroupText>
            <input name="patientName" type="text" onChange={this.handleChangePatientName} value={this.state.patientName} className='form-control' />
            <button onClick={this.filterByPatientName} className="btn btn-primary btn-icon btn-round">
              <i className="now-ui-icons ui-1_zoom-bold mr-1"></i>
            </button>
            </InputGroup>&nbsp;&nbsp;
            <InputGroup
                          className={
                            "no-border input-sm" +
                            (this.state.firstFocus ? " input-group-focus" : "")
                          }
                        >
                            <InputGroupText>
                            Attender name
                            </InputGroupText>

            <input name="attenderName" type="text" onChange={this.handleChangeAttenderName}  value={this.state.attenderName} className='form-control' />
            <button onClick={this.filterByAttenderName} className="btn btn-primary btn-icon btn-round">
              <i className="now-ui-icons ui-1_zoom-bold mr-1"></i>
            </button>
            </InputGroup>
            <InputGroup
                          className={
                            "no-border input-sm" +
                            (this.state.firstFocus ? " input-group-focus" : "")
                          }
                        >
                            <InputGroupText>
                            Phone
                            </InputGroupText>

            <input name="phone" type="text" onChange={this.handleChangePhone}  value={this.state.phone} className='form-control' />
            <button onClick={this.filterByPhone} className="btn btn-primary btn-icon btn-round">
              <i className="now-ui-icons ui-1_zoom-bold mr-1"></i>
            </button>
            </InputGroup>
            </Card>
            </Collapse><br/>
              <TableContainer component={Paper}>
              <div style={{color: "grey"}}>{message}</div>
              <div style={{color: "grey"}}>  Requests count: {this.props.response.patient.hasOwnProperty('allPatientRequests') ? this.props.response.patient.allPatientRequests.totalElements : ''}</div>
                <Pagination size="sm" onClick={(event) => this.pageChanged(event)} >
                  {this.constructPaginationLinks(totalPages,currentPage)}
                </Pagination>
                <Table className="table" size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="right">Status</TableCell>
                      <TableCell align="right">Patient Name</TableCell>
                      <TableCell align="right">Attender</TableCell>                      
                      <TableCell align="right">Phone</TableCell>                      
                      <TableCell align="right">Blood&nbsp;Group</TableCell>          
                      <TableCell align="right">Units</TableCell>
                      <TableCell align="right">
                        <i onClick={() => this.sortChanged('ASC')} className="now-ui-icons arrows-1_minimal-up mr-1"></i>
                        <i onClick={() => this.sortChanged('DESC')} className="now-ui-icons arrows-1_minimal-down mr-1"></i>
                        Required By
                      </TableCell>
                      <TableCell align="right">Hospital</TableCell>      
                      <TableCell align="right">Age</TableCell>
                      <TableCell align="right">Gender</TableCell>
                      <TableCell align="right">District</TableCell>
                      <TableCell align="right">PinCode</TableCell>
                      <TableCell align="right">Purpose</TableCell>
                      <TableCell align="right">Notes</TableCell>
                      <TableCell align="right">Last modified by</TableCell>
                      <TableCell align="right">Last modified at</TableCell>  
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {this.props.response.patient.allPatientRequests && this.props.response.patient.allPatientRequests.content ? this.props.response.patient.allPatientRequests.content.map((row,index) => (
                      <TableRow key={row.id} onClick={() => this.handlePatientClick(index)}>
                        <TableCell align="right">{row.status}</TableCell>
                        <TableCell align="right">{row.fullname}</TableCell>
                        <TableCell align="right">{row.attender}</TableCell>
                        <TableCell align="right">{row.phone}</TableCell>                        
                        <TableCell align="right">{row.bloodGroup}</TableCell>
                        <TableCell align="right">{row.units}</TableCell>
                        <TableCell align="right">{row.requiredBy}</TableCell> 
                        <TableCell align="right">{row.hospitalName}</TableCell>                                     
                        <TableCell align="right">{row.age}</TableCell>
                        <TableCell align="right">{row.gender}</TableCell>
                        <TableCell align="right">{row.district}</TableCell>
                        <TableCell align="right">{row.pincode}</TableCell>
                        <TableCell align="right">{row.purpose}</TableCell>
                        <TableCell align="right">{row.notes}</TableCell>
                        <TableCell align="right">{row.modifiedBy}</TableCell>
                        <TableCell align="right">{moment(row.modifiedTimestamp).format('DD-MM-YYYY HH:mm')}</TableCell>
                      </TableRow>
                    )) : ''}
                  </TableBody>
                </Table>
                <Pagination size="sm" onClick={(event) => this.pageChanged(event)} >
                  {this.constructPaginationLinks(totalPages,currentPage)}
                </Pagination>                
                <div style={{color: "grey"}}>{message}</div>
                <div style={{color: "grey"}}>  Requests count: {this.props.response.patient.hasOwnProperty('allPatientRequests') ? this.props.response.patient.allPatientRequests.totalElements : ''}</div>    
              </TableContainer>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  return <LiquidLoveRequests navigate={navigate} {...props} />
});